/* eslint-disable react/no-danger */
import {
  NavigationPage,
  DocumentationPage,
  getDocumentBySlug,
  getAllDocuments,
  getDocumentTree,
  DocumentationVersion,
} from 'src/lib/docs-api';
import React, { useEffect, useRef } from 'react';
import Layout from 'src/components/article.layout';
import { GetStaticPaths, GetStaticProps } from 'next';

interface DocumentationPageProps {
  version: DocumentationVersion;
  post: DocumentationPage;
  documentList: NavigationPage[];
}

export default function Document({
  version,
  post,
  documentList,
}: DocumentationPageProps): any {
  const documentationTarget = useRef(null);

  useEffect(() => {
    async function initialiseDocs() {
      // initialise interactive documentation elements
      if (documentationTarget) {
        const documentationScripts =
          // eslint-disable-next-line import/extensions
          (await import('src/core/docs.min.js')).default;
        documentationScripts.init({ rootEl: documentationTarget.current });
      }
    }
    initialiseDocs();
  });

  return (
    <Layout
      version={version}
      title={post.title}
      description={`${
        post.description
          ? post.description
          : `${post.title} on the Domain Developer Portal`
      }`}
      documentList={documentList}
    >
      <div
        dangerouslySetInnerHTML={{ __html: post.html }}
        ref={documentationTarget}
      />
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  let convertedSlug = ['getting-started']; // default to "getting-started" when no slug supplied == the version index page
  const params = context.params;

  const versionProp: DocumentationVersion = (params?.version?.toString() ??
    null) as DocumentationVersion;

  if (params?.slug) {
    convertedSlug = Array.isArray(params?.slug) ? params?.slug : [params?.slug];
  }
  const post = getDocumentBySlug(versionProp, convertedSlug);
  return {
    props: {
      version: versionProp,
      post,
      documentList: getDocumentTree(versionProp, convertedSlug.join('/')),
    },
  };
};

function getVersionPaths(version: DocumentationVersion) {
  const posts = getAllDocuments(version);
  return posts
    .filter((post) => !post.path.includes('/references/'))
    .map((post) => ({
      params: {
        slug: post.path.split('/'),
        version,
      },
    }));
}

export const getStaticPaths: GetStaticPaths = async () => {
  const versions: DocumentationVersion[] = ['v1', 'v2', 'beta', 'latest'];
  const paths = ([] as any[]).concat(
    ...versions.map((version) => getVersionPaths(version)),
  );

  // This is the root page at the root of each /version/ -> maps to getting-started
  const versionIndexPages = versions.map((version) => ({
    params: {
      slug: [],
      version,
    },
  }));

  return {
    paths: [...paths, ...versionIndexPages],
    fallback: false,
  };
};
